import React, { Component } from 'react';
import $ from 'jquery'
import { Link } from 'react-router-dom';
import AppLogo_white from '../../images/AppLogo_white.jpeg'

class LandingLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  render() {

    return (

      <div class="LandingLayout_Container" >
        <div class="container">
          <div class="row">

            <div class="col-lg-4 col-md-6 col-4 col-xs-12" style={{ padding: "0px" }}>
              <div class="logo-area" style={{ paddingBottom: "10px" }}>
                <img class="Landingpage-topicon" src={AppLogo_white} />
              </div>
            </div>

            <div class="col-lg-8 col-md-6 col-8 col-xs-12" style={{ paddingLeft: "0px" }}>
              <div class="LandingLayout_menu" style={{ color: "white" }}>
                <span style={{ position: "relative", top: "20px" }}>
                  <Link to="Login"><button type="button" class="btn btn_style2" style={{ borderRadius: "0px", fontWeight: "600" }}>Log in</button></Link>
                  | <Link to="/Register" class="">Sign up</Link>
                </span>
                {/* <span style={{position:"relative",top:"25px"}}><Link to="/Login" style={{color:"white"}}>Log in</Link> */}

                {/* </span> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  componentDidMount() {
  }

}

export { LandingLayout as default };